import BaseModel from './BaseModel'

export default class PartInvoice extends BaseModel {
  // ... Part-specific methods or overrides ...
}
